/* eslint-disable */
export default {
  downloadSuccess: 'Registro baixado.',
  downloadFail: 'Falha no download do registro de erros. Tente novamente.',
} as const;

// @key: @#@"downloadSuccess"@#@ @source: @#@"Log downloaded."@#@
// @key: @#@"downloadFail"@#@ @source: @#@"Error log download failed. Please try again."@#@
